export const projects = [
    {
        img: 'https://i.imgur.com/idX56Xd.png',
        href: 'https://www.fatecmogidascruzes.com.br/animaTerra',
        alt: 'Logotipo da Revista Eletrônica AnimaTerra',
        title: 'UML modelo4+1 viewsandbeyond',
        subtitle: 'Publicação em revista do projeto arquitetural Líbero',
        desc: 'Design e documentação arquitetural de um WebApp educacional com roadmaps.',
    },
    {
        img: 'https://raw.githubusercontent.com/evitarafadiga/svelte-springboot/master/images/18018_localhost.jpeg',
        href: 'https://github.com/evitarafadiga/svelte-springboot',
        alt: 'Landing page do Líbero',
        title: 'java springboot svelte sql',
        subtitle: 'Líbero',
        desc: 'WebApp educacional, trabalho de conclusão de curso da faculdade, publicado em revista.',
    },
    {
        img: 'https://miro.medium.com/v2/resize:fit:828/format:webp/1*gNBiZD-Fp08skhnePdtfDA.png',
        href: 'https://medium.com/@lazvsantos/how-to-use-tidal-on-linux-f2e50e063f57',
        alt: 'Imagem customizada do jogo Club Penguin',
        title: 'linux shellscript api',
        subtitle: 'How to use Tidal on Linux',
        desc: 'Artigo sobre qualidade de áudio do serviço de streaming Tidal, na plataforma Linux (31 mil leituras).',
    },
    {
        img: 'https://raw.githubusercontent.com/lucasmonstrox/PyTibia/main/docs/assets/images/client.png',
        href: 'https://github.com/lucasmonstrox/PyTibia',
        alt: 'Imagens do cliente de PyTibia',
        title: 'PYTHON UML',
        subtitle: 'PyTibia',
        desc: 'O PixelBot mais rápido do Tibia para obter fps desbloqueados que contou com a minha ajuda na estrutura e arquitetura de software.',
    },
    {
        img: 'https://i.imgur.com/rW4WZLP.png',
        href: 'https://github.com/evitarafadiga/eProducts',
        alt: 'Página de loja do eProducts',
        title: '.net c# sql',
        subtitle: 'eProducts',
        desc: 'E-commerce de móveis.',
    },
    {
        img: 'https://raw.githubusercontent.com/evitarafadiga/chuva-inc.github.io/main/src/public/preview.png',
        href: 'https://github.com/evitarafadiga/chuva-inc.github.io',
        alt: 'Landing page de site-exercício de front-end',
        title: 'javascript svelte',
        subtitle: 'Reprodução de site',
        desc: 'Exercício de front-end de processo seletivo.',
    },
    {
        img: 'https://i.imgur.com/TOdrBKP.gif',
        href: 'https://github.com/evitarafadiga/sewers-crumble',
        alt: 'Imagens do jogo Sewers Crumble',
        title: 'C# Unity',
        subtitle: 'Sewers Crumble (Caldo de Esgoto)',
        desc: 'Jogo de terror e sobrevivência multiplataforma, obtendo mais de 50 downloads apesar de ainda estar em fase beta.',
    },
    {
        img: 'https://i.imgur.com/N9FqsrN.png',
        href: 'https://github.com/evitarafadiga/fecap-api',
        alt: 'Landing page de API',
        title: 'react javascript tailwindcss mysql',
        subtitle: 'API FullStack',
        desc: 'Exercício de API de processo seletivo com criação de pessoas, login e especificações do teste.',
    },
    {
        img: 'https://i.imgur.com/sHySDMR.png',
        href: 'https://github.com/evitarafadiga/nextjs-eleven-dragons',
        alt: 'Landing page de API',
        title: 'nextjs javascript',
        subtitle: 'API Fullstack',
        desc: 'Exercício de API de processo seletivo com criação de usuários e especificações do teste.',
    },
    {
        img: 'https://i.imgur.com/8n8TWrL.png',
        href: 'https://github.com/evitarafadiga/todolist',
        alt: 'Telas de aplicação lista de tarefas',
        title: 'Javascript reactnative realm',
        subtitle: 'Lista de tarefas',
        desc: 'App mobile com local storage para armazenamento de lista de tarefas.',
    },
    {
        img: 'https://i.imgur.com/RLLepQB.png',
        href: 'https://github.com/evitarafadiga/ultrajante-react',
        alt: 'Imagens do jogo Ultrajante Beta',
        title: 'javascript react tailwindcss',
        subtitle: 'Ultrajante Beta',
        desc: 'Jogo de cartas baseado em turnos, projeto de criação de cartas e game design.',
    },
    {
        img: 'https://i.imgur.com/yIHGQmt.gif',
        href: 'https://github.com/evitarafadiga/ClasseCastorBeta',
        alt: 'Printscreen da tela de personagens de ClasseCastorBeta',
        title: 'c# unityengine',
        subtitle: 'Classe Castor Beta',
        desc: 'Jogo infantil 3D, meu primeiro projeto na área de desenvolvimento.',
    },
]